import type { CheckboxValue } from './input/checkbox-group/types';
import type {
  CategoryCheckbox,
  CategoryChoice,
  CategoryConditionSelect,
  CategoryInput,
  CategoryRange,
  CategorySelect,
} from './types';

export const isCategoryCheckbox = (value: CategoryInput):
value is CategoryCheckbox => value.type === 'checkbox';

export const isCategoryChoice = (value: CategoryInput):
value is CategoryChoice => value.type === 'choice';

export const isCategoryConditionSelect = (value: CategoryInput):
value is CategoryConditionSelect => value.type === 'conditionSelect';

export const isCategoryRange = (value: CategoryInput):
value is CategoryRange => value.type === 'range';

export const isCategorySelect = (value: CategoryInput):
value is CategorySelect => value.type === 'select';

export const updateCheckedValues = (
  values: Record<string, CheckboxValue>,
  checked: boolean,
) => {
  const updatedValues: Record<string, CheckboxValue> = {};

  for (const key in values) {
    if (Object.prototype.hasOwnProperty.call(values, key)) {
      updatedValues[key] = {
        ...values[key],
        checked,
      };
    }
  }

  return updatedValues;
};
